export interface TimeOffTypeClass {
    AccountTimeOffTypeId : string
    AccountTimeOffType:string
    IsTimeOffRequestRequired:boolean
    AccountId: number
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

const common = {    
    AccountTimeOffType:"",
    IsTimeOffRequestRequired:false,
    IsDisabled:false
  };
  
  export const TimeOffTypeInitialsForAdd = { ...common };
  
  export const TimeOffTypeInitialsForUpdate = {
    ...common,
    AccountTimeOffTypeId:0
  };
  


// export const TimeOffTypeInitialsForApp = {
//     AccountTimeOffType:"",
//     IsTimeOffRequestRequired:false,
//     IsDisabled:false
// }

// export const TimeOffTypeInitialsForUpdate = {
//     AccountTimeOffTypeId:0,
//     AccountTimeOffType:"",
//     IsTimeOffRequestRequired:false,
//     IsDisabled:false
// }